import React from 'react';
import RectangularButton from 'components/elements/molecules/RectangularButton/RectangularButton';

const YES_NO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

const REVIEW_OPTIONS = [
  {
    value: false,
    label: "Yes, I'll review articles first.",
    description:
      'Each week you get an email to approve or remove suggested articles before students see them.',
  },
  {
    value: true,
    label: 'No, auto-publish to students.',
    description:
      'Suggested articles go live automatically each week. You can still edit them any time.',
  },
];

const STUDENT_EMAIL_OPTIONS = [
  {
    value: true,
    label: 'Yes',
    description: "Students get a weekly email with links to this week's readings.",
  },
  {
    value: false,
    label: 'No',
    description: 'Students access readings through the course page only.',
  },
];

function OptionCard({ selected, onClick, label, description }) {
  return (
    <div
      className={`publish-option-card ${selected ? 'is-selected' : ''}`}
      onClick={onClick}
    >
      <div className={`publish-option-radio ${selected ? 'is-selected' : ''}`} />
      <div>
        <div className="publish-option-label">{label}</div>
        {description && (
          <div className="publish-option-desc">{description}</div>
        )}
      </div>
    </div>
  );
}

function SyllabusUploadStepNewsSuggestions({
  value,
  onChange,
  onCancel,
  onSave,
  loading,
  loadingSyllabus,
  saveDisabled,
}) {
  const update = (field, fieldValue) =>
    onChange((prev) => ({ ...prev, [field]: fieldValue }));

  return (
    <div className="syllabus-step">
      <div className="main-con">
        <div className="modal-header">
          <div className="syllabus-step-title">News suggestion preferences</div>
        </div>
        <div className="section-con">
          {loadingSyllabus ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 160 }}>
              <div className="fa fa-spin fa-spinner text-primary" style={{ fontSize: 32 }} />
            </div>
          ) : (
            <>
              <p className="syllabus-preference-label mb-3">
                Should we send you weekly news articles related to your class?
              </p>
              <div className="ml-4 news-pref-cards">
                {YES_NO_OPTIONS.map((opt) => (
                  <OptionCard
                    key={String(opt.value)}
                    selected={value.sendTeacherWeeklyNewsArticles === opt.value}
                    onClick={() => update('sendTeacherWeeklyNewsArticles', opt.value)}
                    label={opt.label}
                  />
                ))}
              </div>
              {value.sendTeacherWeeklyNewsArticles && (
                <>
                  <p className="syllabus-preference-label mb-3 mt-5">
                    Do you want to review the articles before students see them?
                  </p>
                  <div className="ml-4 news-pref-cards">
                    {REVIEW_OPTIONS.map((opt) => (
                      <OptionCard
                        key={String(opt.value)}
                        selected={value.autoPublishWithoutReview === opt.value}
                        onClick={() => update('autoPublishWithoutReview', opt.value)}
                        label={opt.label}
                        description={opt.description}
                      />
                    ))}
                  </div>
                  <p className="syllabus-preference-label mb-3 mt-5">
                    Should students get news suggestions by email?
                  </p>
                  <div className="ml-4 news-pref-cards">
                    {STUDENT_EMAIL_OPTIONS.map((opt) => (
                      <OptionCard
                        key={String(opt.value)}
                        selected={(value.sendStudentsSuggestedReadingsEmail !== false) === opt.value}
                        onClick={() => update('sendStudentsSuggestedReadingsEmail', opt.value)}
                        label={opt.label}
                        description={opt.description}
                      />
                    ))}
                  </div>
                </>
              )}
            </>
          )}
        </div>
        <div className="syllabus-step-footer">
          <div />
          <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
            <RectangularButton onClick={onCancel} disabled={loading}>
              Cancel
            </RectangularButton>
            <RectangularButton
              darkButton
              onClick={onSave}
              disabled={saveDisabled}
            >
              {loading ? 'Saving…' : 'Save'}
            </RectangularButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SyllabusUploadStepNewsSuggestions;
